function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useCallback, useState } from 'react';
import { useDebouncedValue, usePromiseFactory } from '@deephaven/react-hooks';
import useTableUtils from "./useTableUtils.js";
/**
 * Manage a trimmed text value and check if it exists in a list of table columns.
 * @param table The table to check for the value
 * @param columnNames The column names to check
 * @param debounceMs Debounce timer for re-checking the value
 * @param isCaseSensitive Whether the value check is case sensitive
 */
export function useCheckIfExistsValue(table, columnNames, debounceMs, isCaseSensitive) {
  var tableUtils = useTableUtils();
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    valueTrimmed = _useState2[0],
    setValueTrimmed = _useState2[1];
  var _useDebouncedValue = useDebouncedValue(valueTrimmed, debounceMs),
    valueTrimmedDebounced = _useDebouncedValue.value;
  var trimAndUpdateValue = useCallback(text => {
    setValueTrimmed(text.trim());
  }, []);
  var _usePromiseFactory = usePromiseFactory(tableUtils.doesColumnValueExist, [table, columnNames, valueTrimmedDebounced, isCaseSensitive]),
    valueExistsData = _usePromiseFactory.data,
    valueExistsIsLoading = _usePromiseFactory.isLoading;

  // If value check is loading or if debounce hasn't settled, set
  // `matchesExistingValue` to null since it is indeterminate
  var valueExists = valueExistsIsLoading || valueTrimmed !== valueTrimmedDebounced ? null : valueExistsData;
  return {
    valueTrimmed,
    valueTrimmedDebounced,
    valueExists,
    trimAndUpdateValue
  };
}
export default useCheckIfExistsValue;
//# sourceMappingURL=useCheckIfExistsValue.js.map